<template>
    <div class="notes-model">

        <create-note :model="model" :url="url" @success="created"></create-note>

        <div class="list">
            <div class="item" v-for="note in notes" :key="note.id">
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="font-weight-bolder" v-text="`${note.user.name}:`"></h6>
                        <div class="text-sm text-info" v-text="shortDate(note.created_at)"></div>
                    </div>
                    <div>
                        <button class="btn btn-with-icon text-sm" @click="selectedNote = note; openModal('update-note-modal')" v-if="(authorize('admin') || isOwnerOfNote(note))">
                            <i class="fa fa-pen text-primary"></i>
                        </button>
                        <button class="btn btn-with-icon text-sm" @click="selectedNote = note; openModal('delete-note-modal')" v-if="(authorize('admin') || isOwnerOfNote(note))">
                            <i class="fa fa-times text-danger"></i>
                        </button>
                    </div>
                </div>
                <div class="font-italic text-muted pt-1 pb-2">
                    <div class="note-text" v-text="note.note"></div>
                </div>
            </div>
        </div>

        <update-note v-model="selectedNote" v-if="selectedNote" :url="url"></update-note>
        <delete-note :note="selectedNote" v-if="selectedNote" :url="url" @deleted="remove"></delete-note>
    </div>
</template>
<script>
    export default {

        props: {
            model: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                notes: this.model.notes,
                selectedNote: this.model.notes.length ? this.model.notes[0] : null,
            }
        },

        methods: {
            created(note) {
                if (this.notes.length == 0) {
                    this.selectedNote = note;
                }
                this.notes.unshift(note)
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip()
                })
            },

            remove(note) {
                var index = this.notes.indexOf(note);
                this.notes.splice(index, 1);
            },

            isOwnerOfNote(note){
                return note.user.id == App.config.userId
            }
        }
    }
</script>
